module.exports = __webpack_public_path__ + "img/info_icon2.6c0ef8c1.svg";